import H2 from '@material-tailwind/react/Heading2';

export default function Header() {
    return (
        <div className="relative pt-16 flex content-center items-center justify-center h-screen">
            <div className="bg-blog-background bg-cover bg-center absolute top-0 w-full h-full" />
            <div className="container md:w-10/12 relative mx-auto">
                <div className="items-left flex flex-wrap">
                    <div className="w-full md:w-10/12 px-4 mr-auto">
                        <div className='text-white pb-10'>
                        </div>
                        <H2 color="white">
                        </H2>
                    </div>
                </div>
            </div>
        </div>
    );
}
